import { FaqItems } from "./types";

export const faqItems: FaqItems = [
  {
    index: 10,
    category: "Terminology",
    question: "What is the future buyback price?",
    answer:
      "The future buyback price (the amount you’ll pay to purchase the home at the end of the rental period) is <b>agreed upon up-front</b>. This ensures you know exactly how much the property will cost when you’re ready to buy, providing <b>price certainty</b> and avoiding any unwelcome surprises down the line.",
  },
  {
    index: 11,
    category: "Terminology",
    question: "What is converted rent?",
    answer:
      "<b>Converted rent</b> is the portion of your monthly rent that is applied toward decreasing your future buyback price. In our new Rent-to-Own model, <b>100% of each rent payment</b> is converted, meaning it goes straight towards your deposit, helping you build equity faster.",
  },
  {
    index: 1,
    category: "Frequenty asked questions about Keyzy",
    question: "What is Keyzy?",
    answer:
      "Keyzy is a company that helps more people get onto the property ladder with their rent-to-own solution. Every month, 100% of your rental payment converts into your deposit, helping you save automatically toward homeownership, meaning you can accumulate a 10% deposit in the 2 year lease term.",
  },
  {
    index: 2,
    category: "Frequenty asked questions about Keyzy",
    question: "How is this different from a traditional mortgage?",
    answer:
      "Unlike a traditional mortgage, no large upfront deposit is required to move in. Instead, you pay monthly rent that goes entirely toward building your deposit, making it easier to get on the property ladder sooner.",
  },
  {
    index: 3,
    category: "Frequenty asked questions about Keyzy",
    question: "How exactly does the converted rent work?",
    answer:
      "Every month, your full rent amount is going towards decreasing your future buyback price. Over time, this converted rent grows and can be used to purchase the home from Keyzy.",
  },
  {
    index: 4,
    category: "Frequenty asked questions about Keyzy",
    question: "Do I need to pay any upfront fees to start?",
    answer:
      "In most cases, there’s a fixed product fee of £1,999, but there’s no large down payment required at the outset. All details are fully explained before you commit.",
  },
  {
    index: 5,
    category: "Frequenty asked questions about Keyzy",
    question: "What if I want to buy the home sooner than expected?",
    answer:
      "If you’re ready to purchase earlier, you can do so without penalty. 100% of the rent you’ve already paid will go directly toward the buying the property from us. The future buyback price will be the pre-agreed price minus all the rent paid until purchase date.",
  },
  {
    index: 6,
    category: "Frequenty asked questions about Keyzy",
    question: "What happens if I decide not to purchase?",
    answer:
      "If your circumstances change and you choose not to buy, you’ll have the flexibility to walk away at the end of your rental term, subject to any agreed-upon conditions. However, your accrued converted rent may be impacted. Alternatively, you can decide to find a buyer on the open market and you will get the difference between the sale price and the future buyback price minus all your rental payments.     Example: your future buyback price is £500,000 and after two years you have paid £50,000 of rent. You decide to sell the property for £500,000. In that case you would get £50,000 back minus any fees paid as part of the transaction (agents, conveyancing etc. which we would let you know about before proceeding).",
  },
  {
    index: 7,
    category: "Frequenty asked questions about Keyzy",
    question: "Is Keyzy available for any property?",
    answer:
      "Keyzy is available in select regions and for properties that have been pre selected and that meet our criteria (price, condition, location, etc.). Browse our Find a Home section to see all available properties. If you have a specific home in mind, reach out to our team to check if we can help.",
  },
  {
    index: 8,
    category: "Frequenty asked questions about Keyzy",
    question: "Who is responsible for maintenance and repairs?",
    answer:
      "You’ll typically be responsible for minor, day-to-day upkeep, while Keyzy will handle larger structural or significant repairs until you’ve purchased the home. Specific responsibilities are detailed in your agreement.",
  },
  {
    index: 9,
    category: "Frequenty asked questions about Keyzy",
    question: "How do I qualify?",
    answer:
      "We look at factors like income stability and general creditworthiness, but our requirements are usually more flexible than a traditional mortgage lender’s. Get in touch to see if you qualify.",
  },
  {
    index: 10,
    category: "Frequenty asked questions about Keyzy",
    question: " Are there any hidden fees?",
    answer:
      "We believe in full transparency—all fees are clearly stated up front. Aside from your standard rent payments, there are no hidden or surprise fees.",
  },
  {
    index: 11,
    category: "Frequenty asked questions about Keyzy",
    question: " How do I get started?",
    answer:
      "Simply apply online or contact our team. Once approved, we’ll help you find (or secure) a qualifying home. Then, you can move in and start building your deposit with every rent payment.",
  },
];
